const convertToTwoDigit = (num: number): string => {
  if (num / 10 >= 1) {
    return `${num}`;
  } else {
    return `0${num}`;
  }
};
export const formatTimeforOption = (
  seconds: number,
  clockMode: 12 | 24,
  needHandM?: boolean,
  roundMinute = true
): string => {
  const hour = Math.floor(seconds / 3600);
  const minute = Math.floor(seconds / 60) - hour * 60;
  const reminderSecond = seconds - (hour * 3600 + minute * 60);
  let minuteConverted = convertToTwoDigit(
    reminderSecond > 30 && roundMinute ? (minute + 1) % 60 : minute % 60
  );
  minuteConverted = `${minuteConverted}${needHandM ? 'm' : ''}`;

  let hourConverted =
    clockMode === 12 && hour !== 12
      ? hour === 0
        ? '12'
        : hour % clockMode
      : convertToTwoDigit(hour);
  hourConverted = `${hourConverted}${needHandM ? 'h' : ''}`;
  const amPm = clockMode === 12 ? (hour >= 12 ? ' pm' : ' am') : '';
  return `${hourConverted}:${minuteConverted}${amPm}`;
};

export const addSpace = (time: string): string => {
  if (time) {
    if (time.includes('am') || time.includes('pm')) {
      const formattedTime = time.includes('am')
        ? time.split('a')
        : time.split('p');
      return `${formattedTime[0]} ${time.includes('am') ? 'am' : 'pm'}`;
    } else return time;
  }
  return '';
};

export const formatSecondsToHour = (
  seconds: number,
  needHandM?: boolean,
  roundMinute = true
): string => {
  const hour = Math.floor(seconds / 3600);
  const minute = Math.floor(seconds / 60) - hour * 60;
  const reminderSecond = seconds - (hour * 3600 + minute * 60);
  let minuteConverted;
  let hourConverted;
  if (minute === 59) {
    minuteConverted = convertToTwoDigit(
      reminderSecond > 30 && roundMinute ? 0 : minute % 60
    );
    hourConverted = convertToTwoDigit(
      reminderSecond > 30 && roundMinute ? hour + 1 : hour
    );
  } else {
    minuteConverted = convertToTwoDigit(
      reminderSecond > 30 && roundMinute ? (minute + 1) % 60 : minute % 60
    );
    hourConverted = convertToTwoDigit(hour);
  }
  minuteConverted = `${minuteConverted}${needHandM ? 'm' : ''}`;
  hourConverted = `${hourConverted}${needHandM ? 'h' : ''}`;

  return `${hourConverted}:${minuteConverted}`;
};

export const isDurationWithin24Hours = (
  duration: number,
  includeLastSecondForTheDay = true
): boolean =>
  includeLastSecondForTheDay ? duration <= 86400 : duration < 86400;

export const checkInputDuration = (
  textDuration: string
): { parsedSecond: number; isValid: boolean; seconds: number } => {
  textDuration = textDuration.replace(/\s/g, '').toLowerCase();
  let isValid = false;
  let seconds = 0;
  let actualSeconds = 0;
  //hour
  //case: 1, 12, 23
  let match = textDuration.match(/^[0-9]{1,4}$/g);
  if (match) {
    seconds = 60 * 60 * parseInt(match[0]);
    if (seconds < 86400) {
      isValid = true;
    } else {
      seconds = 60 * parseInt(match[0]);
      isValid = isDurationWithin24Hours(seconds);
    }
    actualSeconds = seconds;
  }
  //case: 1h,1H,21h,19H
  match = textDuration.match(/^([0-9]{1,2})h$/g);
  if (match) {
    seconds = 60 * 60 * parseInt(match[0]);
    isValid = isDurationWithin24Hours(seconds);
    actualSeconds = seconds;
  }

  //minute
  //case: 1m,1M,21M,19M,120M,92m
  match = textDuration.match(/^([0-9]{1,4})m$/g);
  if (match) {
    seconds = 60 * parseInt(match[0]);
    isValid = isDurationWithin24Hours(seconds);
    actualSeconds = seconds;
  }
  //case: :1m,:1M,:21M,:19M,:30, :20 ,max=> :1439m :1439
  match = textDuration.match(/^:([0-9]{1,4})m?$/g);
  if (match) {
    let minuteString: any = match[0].split(':')[1];
    if (!textDuration.includes('m')) {
      const minuteValue = parseInt(minuteString);
      minuteString = minuteValue / 10 > 1 ? minuteValue : minuteValue * 10;
    }
    seconds = 60 * parseInt(minuteString);

    isValid = isDurationWithin24Hours(seconds);
    actualSeconds = seconds;
  }
  //case: .1m,.1M,.21M,.19M,.30, .20
  match = textDuration.match(/^\.([0-9]{1,4})m?$/g);
  if (match) {
    let minuteString: any = match[0].split('.')[1];
    if (!textDuration.includes('m')) {
      const minuteValue = parseInt(minuteString);
      minuteString = minuteValue / 10 > 1 ? minuteValue : minuteValue * 10;
    }
    seconds = 60 * parseInt(minuteString);
    isValid = isDurationWithin24Hours(seconds);
    actualSeconds = seconds;
  }

  //full time format
  //case: 2h20m, 12h30m
  match = textDuration.match(/^([0-9]{1,2})h([0-9]{1,2})m?$/g);
  if (match) {
    const timeStringArray = match[0].split('h');
    const { parsedSec, valid, seconds: secs } = convertTimeStringArrayToSeconds(
      timeStringArray
    );
    seconds = parsedSec;
    isValid = valid;
    actualSeconds = secs;
  }

  //case: 2:30, 12:52, 2: == 2h , 3:5 == 3h50m

  match = textDuration.match(/^([0-9]{1,2}:)[0-9]{0,2}$/g);
  if (match) {
    const timeStringArray = match[0].split(':');
    const { parsedSec, valid, seconds: secs } = convertTimeStringArrayToSeconds(
      timeStringArray
    );
    seconds = parsedSec;
    isValid = valid;
    actualSeconds = secs;
  }

  //case: 2h:20m, 12h:30m 12h:
  match = textDuration.match(/^([0-9]{1,2}h:)([0-9]{0,2}m?)?$/g);
  if (match) {
    const timeStringArray = match[0].split(':');
    const { parsedSec, valid, seconds: secs } = convertTimeStringArrayToSeconds(
      timeStringArray
    );
    seconds = parsedSec;
    isValid = valid;
    actualSeconds = secs;
  }
  //case: 2.30, 12.52,
  match = textDuration.match(/^([0-9]{1,2}\.)[0-9]{0,2}$/g);
  if (match) {
    const timeStringArray = match[0].split('.');
    const { parsedSec, valid, seconds: secs } = convertTimeStringArrayToSeconds(
      timeStringArray
    );
    seconds = parsedSec;
    isValid = valid;
    actualSeconds = secs;
  }
  return {
    parsedSecond: isValid ? seconds : 0,
    isValid: isValid,
    seconds: actualSeconds
  };
};

export const convertTimeStringArrayToSeconds = (
  timeStringArray: string[]
): { parsedSec: number; valid: boolean; seconds: number } => {
  let isValid = false;
  let seconds = 0;
  const hourSec = 60 * 60 * parseInt(timeStringArray[0]);
  let minSec = 0;
  if (timeStringArray[1] !== '') {
    const minText = timeStringArray[1].split('');
    minSec =
      minText.length > 1
        ? 60 * parseInt(timeStringArray[1])
        : 60 * parseInt(timeStringArray[1]) * 10;
  }
  if (minSec < 60 * 60) {
    seconds = hourSec + minSec;
    isValid = isDurationWithin24Hours(seconds);
  }
  return {
    parsedSec: isValid ? seconds : 0,
    valid: isValid,
    seconds: seconds
  };
};
